import { render } from "./PostComposer.vue?vue&type=template&id=6cdcb6d3&scoped=true"
import script from "./PostComposer.vue?vue&type=script&lang=js"
export * from "./PostComposer.vue?vue&type=script&lang=js"

import "./PostComposer.vue?vue&type=style&index=0&id=6cdcb6d3&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdcb6d3"]])

export default __exports__